import React from 'react';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import PrimaryButton, { PrimaryButtonProps } from 'components/partials/buttons/primary-button';
import GatsbyImageTag from 'components/partials/parts/gatsby-image-tag';
import { ReactComponent as IconCloseX } from 'img/icons/icon-close-x.svg';

/**
 * suggested image size: 708x460
 */
type PopupCardProps = {
    image?: IGatsbyImageData;
    headline?: string;
    rtecontent?: string;
    onClickClose?: () => void;
    buttonProps?: PrimaryButtonProps;
};

const PopupCard: React.FC<React.PropsWithChildren<PopupCardProps>> = ({ image, headline, rtecontent, onClickClose, buttonProps, children }) => {
    return (
        <div>
            <button className="popup-card__close" onClick={onClickClose}>Close <IconCloseX /></button>
            <div className="popup-card__asset">
                {image && <GatsbyImageTag image={image} alt={headline} />}
            </div>
            <div className="popup-card__content">
                {headline && <h2 className="h1">{headline}</h2>}
                {/* If we have an rtecontent string, use that as the content */}
                {rtecontent &&
                    <div className="rtecontent" dangerouslySetInnerHTML={{ __html: rtecontent }} />
                }
                {/* Otherwise, use this component's children as the content */}
                {!rtecontent &&
                    <div className="rtecontent">{children}</div>
                }

                {buttonProps && <PrimaryButton {...buttonProps} />}
            </div>
        </div>
    );
};

export default PopupCard;